import { useRouter } from "next/dist/client/router";
import { useContext, useRef } from "react";
import { useForm } from "react-hook-form";
import HeadPage from "../../../components/HeadPage/HeadPage";
import Input from "../../../components/Input/Input";
import { ApplicationContext } from "../../../context/ApplicationContext";
import { fetchData } from "../../../fetcher";
import TheMallOutletLayout from "../../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import styles from "../../../styles/pages/form.module.scss";
import Swal from "sweetalert2";
import CloseIcon from "../../../public/assets/icons/closeIcon.svg";
import ReactDOMServer from "react-dom/server";

const PasswordRecovery = ({ menuItems, dataContent, properties }) => {
  const { setShowLoader } = useContext(ApplicationContext);
  const router = useRouter();
  const scrollToRef = useRef(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm();

  const onSubmit = async (event) => {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_FE_COMMON}/reset_password`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: event.email
        }),
      }
    );

    const resjs = await res.json();

    if (resjs) {
      Swal.fire({
        title: properties[resjs.message],
        showCloseButton: true,
        showCancelButton: false,
        showConfirmButton: false,
        closeButtonHtml: ReactDOMServer.renderToString(<CloseIcon />),
      });
    }
  };

  return (
    <TheMallOutletLayout menuItems={menuItems} >
      <HeadPage
        scrollToRef={scrollToRef}
        {...dataContent?.layouts.head.data.blocks}
      />
      <div className={styles.formContainer} ref={scrollToRef}>
        {dataContent &&
          dataContent.layouts.form.data &&
          dataContent.layouts.form.data.items && (
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              <div
                className={styles.title}
                style={{ marginBottom: "2.125rem" }}
                dangerouslySetInnerHTML={{
                  __html: dataContent.layouts.form.data.title,
                }}
              ></div>
              <div style={{fontSize: '1.2em', marginBottom: '10px'}} dangerouslySetInnerHTML={{__html: dataContent.layouts.form.data.intro }}></div>
              {dataContent.layouts.form.data.items.map((f, i) => {
                const d = f.field;

                return (
                  <Input
                    key={"recovery-" + i}
                    name={d.name}
                    placeholder={d.placeholder}
                    type={d.type}
                    errorCheck={errors[d.name]}
                    error={d.error}
                    inputProps={{
                      ...register(`${d.name}`, {
                        required: d.error ? true : false,
                        pattern:
                          d.type === "email"
                            ? /^[a-zA-Z0-9_+-]+(\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9\-]+(\.[a-zA-Z0-9\-]+)*(\.[a-zA-Z]{2,})$/
                            : null,
                      }),
                    }}
                  />
                );
              })}
              <button
                className={styles.button}
                style={{ marginTop: "2.5rem", marginBottom: "11.06rem" }}
              >
                {dataContent.layouts.form.data.button_title}
              </button>
            </form>
          )}
      </div>
    </TheMallOutletLayout>
  );
};

PasswordRecovery.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  let properties = null;
  const { slug } = context.query;

  const resmenu = await fetchData("/init", context.query.locale);
  const data = await fetchData(slug, context.query.locale);
  const resproperties = await fetchData(
    null,
    context.query.locale,
    "GET",
    null,
    null,
    null,
    true
  );

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  if (resproperties) {
    properties = resproperties;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent,
    properties: properties,
  };
};

export default PasswordRecovery;
